import ApiClient from '../../../utils/ApiClient'
import Config from '../../../config'
import MyStableEmailUnsubscribe from './myStableEmailUnsubscribe'

export default () => {
    const apiClient = new ApiClient()
    const myStableEmailUnsubscribe = new MyStableEmailUnsubscribe(Config, apiClient) 
    return Object.keys(myStableEmailUnsubscribe).map(key => store => next => action => myStableEmailUnsubscribe[key](store, next, action))
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/middleware/myStableEmailUnsubscribeFactory.js